import React, { forwardRef } from 'react';
import { MapMarkerIconProps } from './types';
import { getMapMarkerIcon } from './helpers';

const MapMarkerIcon = forwardRef<HTMLDivElement, MapMarkerIconProps>(({ color, groupOrder, iconType = 'default' }, ref) => {
    const icon = getMapMarkerIcon({ color, groupOrder, iconType });

    return (
        <div
            ref={ref}
            style={{
                position: 'absolute',
                width: '29px',
                height: '35px',
                pointerEvents: 'none',
            }}
            dangerouslySetInnerHTML={{ __html: icon.options.html || '' }}
        />
    );
});

MapMarkerIcon.displayName = 'MapMarkerIcon';

export default MapMarkerIcon;

// Export helper functions for direct use
export { getMapMarkerIcon } from './helpers';
export type { MapMarkerIconProps, IconType } from './types';
